export default function getMarginRightLg(value) {
  switch (value) {
    case -44:
      return "lg:-mr-44";
    case -40:
      return "lg:-mr-40";
    case -36:
      return "lg:-mr-36";
    case -32:
      return "lg:-mr-32";
    case -28:
      return "lg:-mr-28";
    case -24:
      return "lg:-mr-24";
    case -20:
      return "lg:-mr-20";
    case -16:
      return "lg:-mr-16";
    case -12:
      return "lg:-mr-12";
    case -8:
      return "lg:-mr-8";
    case -4:
      return "lg:-mr-4";
    case 0:
      return "lg:mr-0";
    case 1:
      return "lg:mr-1";
    case 2:
      return "lg:mr-2";
    case 3:
      return "lg:mr-3";
    case 4:
      return "lg:mr-4";
    case 5:
      return "lg:mr-5";
    case 6:
      return "lg:mr-6";
    case 7:
      return "lg:mr-7";
    case 8:
      return "lg:mr-8";
    case 9:
      return "lg:mr-9";
    case 10:
      return "lg:mr-10";
    case 12:
      return "lg:mr-12";
    case 14:
      return "lg:mr-14";
    case 16:
      return "lg:mr-16";
    case 20:
      return "lg:mr-20";
    case 24:
      return "lg:mr-24";
    default:
      return "";
  }
}
